/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */

import { isPlainObject } from './util/object-utils';

export function validateContainersObject(container: any): void {
	if (!isPlainObject(container)) {
		throw new Error('properties.containers must be an Object');
	}

	if (!('id' in container)) {
		throw new Error("properties.containers is missing field 'id'");
	}

	if (typeof container.id !== 'string') {
		throw new Error('properties.containers.id must be of type String');
	}

	if ('type' in container && typeof container.type !== 'string') {
		throw new Error('properties.containers.type must be of type String');
	}
}
